import React from 'react';
import { Tooltip } from 'antd';
import moment from 'moment-timezone';
import { getTimeZone } from '@utils/timezone';

interface CreatedByProps {
  name?: string | null;
  email?: string | null;
  timestamp?: string | number | Date | null;
}

// Localize to the customer timezone when available; moment already runs in the
// customer tz via the global moment.tz.setDefault, but pass it explicitly so the
// component is correct even when rendered outside that context (e.g. tests).
const formatTimestamp = (timestamp: CreatedByProps['timestamp']): string => {
  if (!timestamp) return '';
  const tz = getTimeZone();
  const m = tz ? moment(timestamp).tz(tz) : moment(timestamp);
  return m.format('MMM D, YYYY h:mm A');
};

// Shared display for rule authorship: name (with the email as a tooltip) plus a
// subtle localized timestamp underneath. Falls back gracefully when a field is
// missing so partial data never renders as "undefined".
const CreatedBy = ({ name, email, timestamp }: CreatedByProps) => {
  const displayName = name || email || 'Unknown';
  const when = formatTimestamp(timestamp);

  const nameNode = email ? (
    <Tooltip title={email}>
      <span>{displayName}</span>
    </Tooltip>
  ) : (
    <span>{displayName}</span>
  );

  return (
    <div style={{ lineHeight: 1.3 }}>
      <div style={{ fontWeight: 500 }}>{nameNode}</div>
      {when ? <div style={{ fontSize: 12, color: '#8c8c8c' }}>{when}</div> : null}
    </div>
  );
};

export default CreatedBy;
